import { weatherTemperatureRangeText } from './OtherDayCard.locstring.json';
import { DataFromText } from 'owa-locstrings/lib/strings/datafromtext.locstring.json';
import { percentage, percentageAriaLabel } from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import * as React from 'react';

import { ControlIcons } from 'owa-control-icons';

import { Icon } from '@fluentui/react/lib/Icon';
import WeatherAnimation, {
    Direction,
    WeatherAnimationProps,
    WeatherAnimationState,
} from './WeatherAnimation';
import { observer } from 'mobx-react-lite';

const OtherDayCard = observer(
    ({ styles, iconClass, temperatureData, attribution }: WeatherAnimationProps) => (
        <>
            <figure className={styles.skyCodeIcon}>
                <i className={iconClass} />
                <figcaption className={styles.weatherString}>
                    {format(
                        loc(weatherTemperatureRangeText),
                        temperatureData.tempHigh,
                        temperatureData.tempLow,
                        temperatureData.weatherString
                    )}
                </figcaption>
            </figure>
            <div className={styles.weatherForecastDetails}>
                <span className={styles.forecastPrecipitation}>
                    <Icon iconName={ControlIcons.Drop} ariaLabel={loc(percentageAriaLabel)} />
                    {format(loc(percentage), temperatureData.precipitation)}
                </span>
                <span className={styles.weatherAttribution}>
                    {format(loc(DataFromText), attribution)}
                </span>
            </div>
        </>
    )
);

export interface ExtraInterfaces {
    Direction: Direction;
    WeatherAnimationState: WeatherAnimationState<WeatherAnimationProps>;
}

export default WeatherAnimation(OtherDayCard) as React.ComponentClass<WeatherAnimationProps>;
